(() => {
  const hoverOk = window.matchMedia('(hover: hover) and (pointer: fine)');

  const closeOthers = (keep) => {
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach((details) => {
      if (details !== keep) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const bind = (menu) => {
    const details = menu.querySelector('details.mega-menu');
    if (!details) return;

    const summary = details.querySelector('summary');
    let closeTimer;

    const open = () => {
      if (!hoverOk.matches) return;
      clearTimeout(closeTimer);
      closeOthers(details);
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      closeTimer = window.setTimeout(() => {
        if (menu.matches(':hover') || details.contains(document.activeElement)) return;
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
      }, 120);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);
  };

  const start = () => {
    document.querySelectorAll('header-menu').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
